import { Container, Row, Col} from 'react-bootstrap'
import Location from './Location'
import Events from './Events'

const Info = () => {

  return (
    <Container className='d-flex justify-content-center align-items-center w-100'>
        <Row> 
            <Col sm= {6}> 
                <Location/>
            </Col>
            <Col sm= {6}> 
                <Events/>
            </Col>
        </Row>
    </Container>
  );
};

export default Info;
